import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { AnalysisReportState, AnalysisReportApiResponse } from '../types';

const initialState: AnalysisReportState = {
  reports: [],
  currentPage: 0,
  totalPages: 0,
  itensPerPage: 0,
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReportsAction(state, action: PayloadAction<AnalysisReportApiResponse>) {
      state.reports = action.payload.reports;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.itensPerPage = action.payload.itensPerPage;
    },

    clearReportsAction(state) {
      state.reports = [];

      state.currentPage = 0;
      state.totalPages = 0;
      state.itensPerPage = 0;
    },
  },
});

export const { setReportsAction, clearReportsAction } = reportsSlice.actions;

export const getReports = (state: RootState): AnalysisReportState => state.reports;

export default reportsSlice.reducer;
